<template>
  <div>
    <div class="text-center mb-5">
      We received your password reset request. If we can find an account
      associated with {{ email }}, we will send a password reset link to that
      email address.
    </div>
      <!--
    <v-form class="full-width">
      <v-btn color="primary" @click="goBack" block large rounded>
        <div class="font-size-md font-weight-semibold">ok</div>
      </v-btn>
    </v-form>
      -->
      <v-btn color="primary" @click="goBack" block large rounded>
        <div class="font-size-md font-weight-semibold">ok</div>
      </v-btn>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ResetPasswordRequestConfirmation",
  computed: {
    ...mapState({
      email: (state) => state.auth.email,
    }),
  },
  methods: {
    goBack() {
      this.closeAuth ? this.closeAuth() : this.$router.go(-2);
    },
  },
  props: { closeAuth: Function },
};
</script>
